import { useLoaderContext, type LoaderContext } from "~/providers/LoaderProvider"

/**
 * Return data from a specific loader.
 * @see https://remix.run/docs/en/main/hooks/use-route-loader-data
 */
export function useRouteLoaderData(route: "root"): LoaderContext["rootLoaderData"]
export function useRouteLoaderData(route: "routes/$site"): LoaderContext["siteLoaderData"]
export function useRouteLoaderData(route: "root" | "routes/$site"): LoaderContext["rootLoaderData"] | LoaderContext["siteLoaderData"] {
  const loaderData = useLoaderContext()
  if ("root" === route) return loaderData.rootLoaderData
  if ("routes/$site" === route) return loaderData.siteLoaderData
  throw new Error(`Loader route ${route} not recognized.`)
}
